(function (angular) {
	'use strict';

	angular
		.module('viewUpdateModule', [
			'apiModule',
			'coreModule',
			'investorUpdatesModule',
			'localStorageModule',
			'mediaGalleryModule',
			'reitElementListingModule'
		])
		.value('globalConfig', globalConfig);
})(window.angular);